import { Wallet, User, FollowSubscribe } from 'entities/Account';

export const isUserHasAccess = (array: Array<FollowSubscribe>, name: string | undefined) => {
  if (!array.length) {
    return false;
  }

  return array.some((item) => item.celebrity?.nickName === name);
};

export const isConnectedWallet = (wallet: Wallet, user: User) => {
  return !user && wallet.address !== '';
};
